import { useEffect, useState } from "react";

let gsapLoadPromise = null;
export function loadGSAP() {
  if (typeof window !== "undefined" && window.gsap && window.ScrollTrigger) return Promise.resolve(window.gsap);
  if (gsapLoadPromise) return gsapLoadPromise;
  gsapLoadPromise = new Promise((resolve, reject) => {
    const coreSrc = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js";
    const stSrc = "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js";
    const loadScript = (src) => new Promise((res, rej) => {
      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) { if (existing.dataset.loaded === "true") return res(); existing.addEventListener("load", () => res()); existing.addEventListener("error", rej); return; }
      const sc = document.createElement("script"); sc.src = src; sc.async = true;
      sc.onload = () => { sc.dataset.loaded = "true"; res(); }; sc.onerror = rej;
      document.head.appendChild(sc);
    });
    loadScript(coreSrc).then(() => loadScript(stSrc)).then(() => {
      if (window.gsap && window.ScrollTrigger) { window.gsap.registerPlugin(window.ScrollTrigger); resolve(window.gsap); }
      else reject(new Error("GSAP failed"));
    }).catch(reject);
  });
  return gsapLoadPromise;
}

export function useGSAP() {
  const [g, setG] = useState(typeof window !== "undefined" ? window.gsap || null : null);
  useEffect(() => {
    let cancelled = false;
    loadGSAP().then((gsap) => { if (!cancelled) setG(gsap); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return g;
}

